import type { TButtonDefault } from "types/buttons.type"
import style from "./ButtonDanger.module.scss"

const { button } = style

export const ButtonDanger = ({
	children,
	className = "",
	onClick,
	type = "button",
	submittable = true,
}: TButtonDefault) => {
	return (
		<button
			type={type}
			onClick={onClick}
			className={`${button} ${className}`}
			disabled={!submittable}
			data-testid="button-danger"
		>
			{children}
		</button>
	)
}
